import { defineComponent as h, useSlots as L, computed as l, useCssModule as R, openBlock as r, createBlock as f, resolveDynamicComponent as z, normalizeClass as T, unref as t, withCtx as V, createElementBlock as k, Fragment as C, renderSlot as u, createCommentVNode as p } from "vue";
import { VButtonTags as E, VButtonSizes as o, VButtonVariants as i } from "../../../packages/vsimple-ui/types/VButton.mjs";
import I from "../VSpinner/VSpinner.vue.mjs";
import { VSpinnerSizes as s, VSpinnerVariants as m } from "../../../packages/vsimple-ui/types/VSpinner.mjs";
const X = /* @__PURE__ */ h({
  __name: "VButton",
  props: {
    variant: { default: i.PRIMARY },
    size: { default: o.MEDIUM },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    tag: { default: E.BUTTON },
    rel: { default: null },
    active: { type: Boolean, default: !1 },
    fixedWidth: { type: Boolean, default: !0 },
    href: { default: null },
    target: { default: null },
    type: { default: null },
    fill: { type: Boolean, default: !1 },
    iconRight: { type: Boolean, default: !1 },
    iconOnly: { type: Boolean, default: !1 },
    dataTest: {}
  },
  emits: ["click"],
  setup(v, { emit: y }) {
    const a = v, c = y, S = L(), g = l(() => a.size === o.EXTRA_EXTRA_SMALL ? s.EXTRA_SMALL : a.size === o.EXTRA_SMALL ? s.SMALL : a.size === o.SMALL ? s.SMALL : s.MEDIUM), B = l(() => [i.ACTION, i.ICON, i.GHOST].includes(a.variant) ? m.PRIMARY : m.SECONDARY), b = l(() => !!S.icon), A = l(() => a.loading || a.disabled), n = R();
    return (e, d) => (r(), f(z(e.tag), {
      class: T([
        t(n)["v-button"],
        t(n)[`v-button--${e.variant}`],
        t(n)[`v-button--${e.size}`],
        t(n)[`v-button--${e.type}`],
        {
          [t(n)["v-button--has-icon"]]: !e.loading && b.value,
          [t(n)["v-button--icon-only"]]: e.iconOnly,
          [t(n)["v-button--fill"]]: e.fill,
          [t(n)["v-button--active"]]: e.active,
          [t(n)["v-button--not-fixed-width"]]: !e.fixedWidth
        }
      ]),
      rel: e.rel,
      href: e.href,
      type: e.type || "button",
      target: e.target,
      disabled: A.value || null,
      "data-test": e.dataTest,
      "aria-label": "Button",
      onClick: d[0] || (d[0] = (M) => c("click", M))
    }, {
      default: V(() => [
        e.loading ? (r(), f(t(I), {
          key: 0,
          size: g.value,
          variant: B.value
        }, null, 8, ["size", "variant"])) : (r(), k(C, { key: 1 }, [
          e.iconRight ? p("", !0) : u(e.$slots, "icon", { key: 0 }),
          u(e.$slots, "default"),
          e.iconRight ? u(e.$slots, "icon", { key: 1 }) : p("", !0)
        ], 64))
      ]),
      _: 3
    }, 8, ["class", "rel", "href", "type", "target", "disabled", "data-test"]));
  }
});
export {
  X as default
};
